<div id="convenio-add--popup">
    <form class="form" role="form" autocomplete="off" [formGroup]="addConvenioForm">
        <div class="popoup-hearder">
            <h2 class="m-b-5" mat-dialog-title>Crear Convenios</h2>
        </div>
        <div class="popoup-content">
                <div class="each">
                    <mat-label class="label">Grupo</mat-label>
                    <mat-form-field class="full-width" appearance="fill">
                        <input matInput type="text" formControlName="Grupo">
                    </mat-form-field>
                    <!-- <mat-error
                    *ngIf="addConvenioForm.get('Grupo').invalid && addConvenioForm.get('Grupo').touched">
                    <span *ngIf="addConvenioForm.get('Grupo').hasError">El grupo es obligatorio</span>
                    </mat-error> -->



                      <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                        <mat-icon>keyboard_arrow_down</mat-icon>
                      </button> -->

                      <mat-select id="Convedropdown">
                        <mat-option (click)="selectedMenu(element.grupo)" *ngFor="let element of dataSourceDropdown">
                            {{ element.grupo }}
                        </mat-option>
                      </mat-select>

                      <!-- <mat-menu #menu="matMenu">
                        <button (click)="selectedMenu(element.grupo)" *ngFor="let element of dataSourceDropdown"  mat-menu-item>{{ element.grupo }}</button>
                      </mat-menu> -->


                    <!-- <button mat-button [matMenuTriggerFor]="menu">Grupo</button>
                    <mat-menu [(value)]="selected" #menu="matMenu">
                        

                    </mat-menu> -->

                   
                    <!-- <mat-form-field class="full-width" appearance="fill">
                        <mat-select  formControlName="Grupo">
                            <mat-option *ngFor="let element of dataSourceDropdown" [value]="element.grupo" >{{ element.grupo }}</mat-option>
                        </mat-select>
                    </mat-form-field>-->
                    <mat-error
                    *ngIf="addConvenioForm.get('Grupo').invalid && addConvenioForm.get('Grupo').touched">
                    <span *ngIf="addConvenioForm.get('Grupo').hasError">El grupo es obligatorio</span>
                    </mat-error> 
                   
                </div>
                <div class="each">
                    <mat-label class="label">Nombre</mat-label>
                    <mat-form-field class="full-width" appearance="fill">
                        <input matInput type="text" formControlName="Nombre">
                    </mat-form-field>
                    <mat-error
                    *ngIf="addConvenioForm.get('Nombre').invalid && addConvenioForm.get('Nombre').touched">
                    <span *ngIf="addConvenioForm.get('Nombre').hasError ">El nombre es obligatorio</span>
                    </mat-error>
                    
                    
                </div>
        </div>
        <div class="popoup-footer">
            <button class="keep" (click)="onSave()"><span class="mat-button-wrapper">Guardar</span></button>
            <button class="cancel" (click)="onClose()"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>